import { render, staticRenderFns } from "./AddressBooks.vue?vue&type=template&id=d59f4ab0&"
import script from "./AddressBooks.vue?vue&type=script&lang=ts&"
export * from "./AddressBooks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports